import React, { useEffect, useMemo } from 'react'
// import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setRecord, setTableData } from './store/dataSlice'
// import {
//     HiOutlinePencil,
//     HiOutlineTrash
// } from 'react-icons/hi'
// import Tooltip from 'components/Ui/Tooltip'
import {
    // ConfirmationModal,
    Table,
} from 'components/Ui'
import { getApiData } from 'services/AsnService'
// import { Success } from "utils/alerts";
// import useAuth from 'utils/hooks/useAuth'
// import { asnType, siteLabel, status, supplier } from 'components/helper'
import dayjs from 'dayjs'
import { DatePicker, Select } from 'components/Form'
injectReducer('asn', reducer)

export default function Asn() {
    const dispatch = useDispatch()
    // const { checkPermission } = useAuth()
    // const user = useSelector(state => state.auth.user)
    const { data, tableData, loading } = useSelector(state => state.asn.data)
    const { company, customer } = useSelector(state => state.filterData)
    const { companyData, customersData, wmsAsnStatusFilterData } = useSelector(state => state.listData)

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        tableData.startDate,
        tableData.endDate,
        tableData.status,
        company,
        customer,
    ])

    const fetchData = () =>
        dispatch(
            getData({
                ...tableData,
                company: company ? companyData?.find(item => item?.id?.toString() === company?.toString())?.code : '',
                customer: customer
                    ? customersData?.find(item => item?.id?.toString() === customer?.toString())?.customer_code
                    : '',
            })
        )
    const filterData = () => {
        const sort = tableData?.sort || []
        let filtered = data?.filter(item => {
            // if (customer) {
            //     return item?.customer?.toString() === customer
            // }
            return true
        })

        if (sort?.length > 0) {
            sort?.forEach(({ column, dir }) => {
                filtered = filtered?.sort((a, b) => {
                    const aVal = a[column]
                    const bVal = b[column]
                    if (typeof aVal === 'string' && typeof bVal === 'string') {
                        return dir === 'asc' ? aVal.localeCompare(bVal) : bVal.localeCompare(aVal)
                    } else {
                        return dir === 'asc' ? aVal - bVal : bVal - aVal
                    }
                })
            })
        }
        return filtered || []
    }

    const columns = useMemo(
        () => [
            {
                field: 'Warehouse',
                header: 'Whse',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Company',
                header: 'Company',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Customer',
                header: 'Customer',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Order No',
                header: 'Order Number',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Receipt Type',
                header: 'Receipt Type',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Ref_1',
                header: 'Reference 1',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Ref_2',
                header: 'Reference 2',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total Ordered Qty',
                header: 'Total Ordered Quantity',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total Received Qty',
                header: 'Total Received Quantity',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Total Lines',
                header: 'Total Lines',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Order Status',
                header: 'Order Status',
                className: 'min-w-[150px]',
                orderable: true,
            },
            {
                field: 'Create Date',
                header: 'Create Date',
                className: 'min-w-[150px]',
                renderCell: row => (row?.['Create Date'] ? dayjs(row?.['Create Date']).format('MMM D, YYYY') : ''),
                orderable: true,
            },
            {
                field: 'Last Update',
                header: 'Last Update',
                className: 'min-w-[150px]',
                renderCell: row => (row?.['Last Update'] ? dayjs(row?.['Last Update']).format('MMM D, YYYY') : ''),
                orderable: true,
            },
            // {
            //   header: "Status",
            //   renderCell: (row) => {
            //     return checkPermission("company", "status") ? (
            //       <ConfirmationModal
            //         onConfirm={() => {
            //           handleStatus(row.id, { ...row, is_active: !row.is_active });
            //         }}
            //       >
            //         {status(row.is_active)}
            //       </ConfirmationModal>
            //     ) : (
            //       status(row.is_active)
            //     );
            //   },
            // },
            // {
            //     header: 'Action',
            //     className: 'px-4',
            //     renderCell: row => {
            //         return (
            //             <div className="flex items-center gap-3">
            //                 {checkPermission('asn', 'edit') ? (
            //                     <Tooltip title={'Edit'}>
            //                         <Link to={`/meson-wms/asn/${row.id}/edit`} className="hover:text-primary">
            //                             <HiOutlinePencil size={20} />
            //                         </Link>
            //                     </Tooltip>
            //                 ) : null}
            //                 {checkPermission("company", "delete") ? (
            //       <Tooltip title={"Delete"}>
            //         <ConfirmationModal
            //           message={"Are you sure you want to delete this record!"}
            //           onConfirm={() => {
            //             handleDelete(row.id);
            //           }}
            //         >
            //           <span className="hover:text-danger">
            //             <HiOutlineTrash size={20} />
            //           </span>
            //         </ConfirmationModal>
            //       </Tooltip>
            //     ) : null}
            //             </div>
            //         )
            //     },
            // },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            tableData.startDate,
            tableData.endDate,
            tableData.status,
            company,
            customer,
        ]
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">ASN</h2>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 mb-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg">
                <Select
                    id="status"
                    name="status"
                    label="Status"
                    placeholder={'Status'}
                    value={tableData.status}
                    className="min-w-28"
                    options={wmsAsnStatusFilterData}
                    onChange={e => dispatch(setTableData({ ...tableData, status: e.target.value }))}
                />
                <DatePicker
                    id="satrt_date"
                    name="satrt_date"
                    label="Created Date"
                    placeholder="Start Date"
                    value={tableData.startDate}
                    onChange={e => dispatch(setTableData({ ...tableData, startDate: e.target.value }))}
                    className="w-full"
                />
                <DatePicker
                    id="end_date"
                    name="end_date"
                    label="Closed Date"
                    placeholder="End Date"
                    value={tableData.endDate}
                    onChange={e => dispatch(setTableData({ ...tableData, endDate: e.target.value }))}
                    className="w-full"
                />
            </div>
            <div className="bg-white border rounded-sm border-stroke shadow-default dark:border-strokedark dark:bg-boxdark">
                <Table
                    loading={loading}
                    filter={false}
                    download={true}
                    datas={filterData()}
                    columns={columns}
                    pagingData={tableData}
                    onChange={e => dispatch(setTableData(e))}
                    csvDownloadApi={getApiData}
                    view={'/meson-wms/asn/'}
                    setRecord={setRecord}
                    viewId={'Order No'}
                />
            </div>
        </>
    )
}
